const WrapperActionTypes = {
  ACTIVE_VIEW: 'ACTIVE_VIEW',
  DESACTIVE_VIEW: 'DESACTIVE_VIEW',
};

export default WrapperActionTypes;
